const $ = require('jquery')
const Vue = require('vue')
const { client, guid } = require('sci/helpers')
const R = require('ramda')
const { sprintf } = require('sci/utils')

const nullify = (value) => {
    if (value === '') {
        return null
    }

    return value
}

const defaultFormat = (state) => state.text
const noop = (x) => x
const ellipsify = (template) => `<div style="margin-right: 0; display: block; position: relative; text-overflow: ellipsis; overflow: hidden;">${template}</div>`

const buildSelect2 = (self, cb, value) => {
    const $select = $(self.$els.select)

    const key = self.display
    const id = self.identifier

    $select
        .prop('disabled', self.disabled)
        .empty()
        .unbind()
        .select2({
            language: {
                errorLoading: function () {
                    return 'Os resultados não puderam ser carregados.'
                },
                inputTooLong: function (args) {
                    const overChars = args.input.length - args.maximum

                    let message = 'Apague ' + overChars + ' caracter'

                    if (overChars !== 1) {
                        message += 'es'
                    }

                    return message
                },
                inputTooShort: function (args) {
                    const remainingChars = args.minimum - args.input.length

                    return 'Digite ' + remainingChars + ' ou mais caracteres'
                },
                loadingMore: function () {
                    return 'Carregando mais resultados…'
                },
                maximumSelected: function (args) {
                    let message = 'Você só pode selecionar ' + args.maximum + ' ite'

                    if (args.maximum === 1) {
                        message += 'm'
                    } else {
                        message += 'ns'
                    }

                    return message
                },
                noResults: function () {
                    return 'Nenhum resultado encontrado'
                },
                searching: function () {
                    return 'Buscando…'
                }
            },
            minimumInputLength: self.min,
            templateResult: (state, container) => {
                if (state.hasOwnProperty('__auto')) {
                    return state.text
                }

                if (self.templateResult && self.templateResult !== defaultFormat) {
                    if (state.hasOwnProperty(id)) {
                        return self.templateResult(state.original, container)
                    }
                }

                return defaultFormat(state)
            },
            templateSelection: (state, container) => {
                if (state.hasOwnProperty('__auto')) {
                    return state.text
                }

                if (self.templateSelection && self.templateSelection !== defaultFormat) {
                    if (state.hasOwnProperty(id)) {
                        const template = self.templateSelection(state.original, container)

                        return ellipsify(template)
                    }
                }

                const template = defaultFormat(state)

                return template
            },
            escapeMarkup: self.formatResult !== defaultFormat ? noop : undefined,
            ajax: {
                url: `${self.url}?simple=true`,
                dataType: 'json',
                delay: 100,
                matcher: function () {
                    return true
                },
                data: function (params) {
                    let additionalData = {}
                    if (self.urlData) {
                        additionalData = self.urlData;
                    }

                    return {
                        search: params.term,
                        page: params.page,
                        ...additionalData
                    }
                },
                transport: function (params, success, failure) {
                    client
                        .silent()
                        .get('Carregando...', params.url, { ...params.data, ...self.query })
                        .then((res) => {
                            if (!res || !res.data || res.errors.length > 0) {
                                const errors = R.filter(_ => _.field === 'search', res.errors)

                                let message = 'Nada encontrado.'

                                if (errors.length > 0) {
                                    message = R.head(errors).message
                                }

                                success({
                                    data: [
                                        {
                                            __auto: true,
                                            disabled: true,
                                            id: 0,
                                            text: message
                                        }
                                    ]
                                })
                                return
                            }

                            success(res)
                        })
                        .catch((ex) => {
                            console.error(ex)
                            failure(ex)
                        })
                },
                processResults: function (data, params) {
                    const remaining = R.path(['meta', 'pagination', 'remaining'], data) || 0
                    const currentPage = R.path(['meta', 'pagination', 'current_page'], data) || 1

                    try {
                        let items = data.data

                        if (self.processResult) {
                            items = self.processResult(items, params.term || null)
                        }

                        if (currentPage === 1 && self.headOptions) {
                            items = self.headOptions(items, params.term || null).concat(items)
                        }

                        if (remaining < 1 && self.lastOptions) {
                            items = items.concat(self.lastOptions(items, params.term || null))
                        }

                        items = items.map(item => {
                            if (item.hasOwnProperty('__auto')) {
                                return item
                            }

                            item.original = Object.assign({}, item)
                            item.text = item[key]
                            item.id = item[id]

                            return item
                        })

                        return {
                            results: items,
                            pagination: {
                                more: remaining > 0
                            }
                        }
                    } catch (e) {
                        console.error(e)

                        return null
                    }
                },
                cache: true
            },
            tags: false,
            // dropdownParent: $('body'),
            // minimumResultsForSearch: 5,
            id: guid(),
            theme: 'bootstrap',
            dropdownAutoWidth: true,
            width: 'auto',
            allowClear: self.allowEmpty,
            placeholder: {
                id: null,
                text: self.placeholder || 'Selecione...'
            },
            initSelection: value ? function (select, callback) {
                callback({
                    id: value[id],
                    text: value[key],
                    original: value
                })
            } : null
        })
        .on('change', function () {
            cb.apply(this, arguments)
        })

    // if (value) {
    //     $select.select2('val', value[id])
    // }

    // $select.select2('val', value)
}

Vue.component('form-remote-select', {
    props: {
        noRefetch: {
            type: Boolean,
            default: false
        },
        hasLabel: {
            type: Boolean,
            default: true
        },
        urlData: {
            type: Object,
            default() {
                return {}
            }
        },
        label: {
            type: String
        },
        identifier: {
            type: String,
            default: 'id'
        },
        display: {
            type: String,
            default: 'name'
        },
        placeholder: {
            type: String
        },
        iconClass: {
            type: String
        },
        model: {
            twoWay: true,
            default: null
        },
        disabled: {
            default: false,
            type: Boolean
        },
        onChange: {
            default: null,
            type: Function
        },
        onPrefetched: {
            default: null,
            type: Function
        },
        onSelected: {
            default: null,
            type: Function
        },
        onAfterChanged: {
            default: null,
            type: Function
        },
        allowEmpty: {
            type: Boolean,
            default: true
        },
        hint: {
            type: String,
            default: null
        },
        fieldName: {
            type: String,
            default: null
        },
        url: {
            required: true,
            type: String
        },
        itemUrl: {
            type: String,
            default: null
        },
        query: {
            type: Object,
            default () {
                return {}
            }
        },
        min: {
            type: Number,
            default: null
        },
        templateResult: {
            type: Function,
            default: defaultFormat
        },
        templateSelection: {
            type: Function,
            default: defaultFormat
        },
        processResult: {
            type: Function,
            default: null
        },
        headOptions: {
            type: Function,
            default: null
        },
        lastOptions: {
            type: Function,
            default: null
        }
    },
    watch: {
        disabled () {
            $(this.$els.select).prop('disabled', this.disabled)
        },
        model (newVal) {
            if (!this.model) {
                this.value = null
            }

            this.load()
        }
    },
    methods: {
        holderClass () {
            return this.iconClass ? 'input-icon' : null
        },
        reload () {
            const self = this

            buildSelect2(self, function (evt, ignore) {
                if (ignore) {
                    return
                }

                const realValue = $(this).select2('data')[0]

                if (self.onChange) {
                    self.onChange(this.value, realValue ? realValue.original : null)
                }

                self.value = realValue ? realValue.original : null
                self.model = nullify(this.value)

                if (self.onAfterChanged) {
                    self.onAfterChanged(this.value, realValue ? realValue.original : null)
                }
            }, self.value)
        },
        focus () {
            Vue.nextTick(() => {
                const field = $(this.$els.select)
                field.select2('focus')
                field.select2('open')
            })
        },
        close () {
            Vue.nextTick(() => {
                const field = $(this.$els.select)

                field.select2('close')

                field.blur()

                // TODO: matar select2
                $('#fake-input-because-select2-cant-blur').trigger('mousedown mouseup click').focus()
            })
        },
        makeItemUrl (id) {
            if (this.itemUrl) {
                return sprintf(this.itemUrl, id)
            }

            return `${this.url}/${id}?simple=true`
        },
        load () {
            if (this.model) {
                this.loading = true
                client
                    .background()
                    .get(null, this.makeItemUrl(this.model))
                    .then((res) => {
                        this.loading = false

                        if (!this.model) {
                            this.value = null
                        } else {
                            this.value = res.data

                            if (this.onPrefetched) {
                                this.onPrefetched(res.data.id, res.data)
                            }
                        }

                        Vue.nextTick(() => this.reload())
                    })
            } else {
                Vue.nextTick(() => this.reload())
            }
        },
        getHint () {
            if (this.hint) {
                return this.hint
            }
        }
    },
    data () {
        return {
            loading: false,
            value: null,
            loadingMessage: 'Carregando...'
        }
    },
    ready () {
        if (!this.fieldName) {
            this.fieldName = this._props.model.raw
        }

        if (!this.placeholder) {
            this.placeholder = this.label
        }

        this.load()
    },
    template: `
            <div class="form-group">
                <form-label v-if="hasLabel" :hint="getHint()">
                    <slot name="label">
                        {{ label }}
                    </slot>
                </form-label>
                
                <div v-if="loading">
                    <form-fake-text :disabled="true" :model.sync="loadingMessage"></form-fake-text>
                </div>
                
                <div v-if="!loading">
                    <select class="form-control"
                            v-el:select
                            v-bind:data-field="fieldName"
                            v-bind:disabled="loading || disabled">
                            <option v-if="allowEmpty" value=""></option>
                    </select>
                </div>
            </div>
        `
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/remote-select.js